// extracted by mini-css-extract-plugin
export default {"CustomerListItemContainer":"style_CustomerListItemContainer__W6HE8","namePhoneContainer":"style_namePhoneContainer__t4G-M"};